import React from 'react';
import Markdown from 'markdown-to-jsx';

// Dialogue is authored by staff, but URLs and markup still come from saved content.
const DialogueLink: React.FC<React.AnchorHTMLAttributes<HTMLAnchorElement>> = ({ href, title, children }) => {
  let url: URL;
  try {
    url = new URL(href || '');
    if (!['https:', 'http:', 'mailto:'].includes(url.protocol)) return <>{children}</>;
  } catch {
    return <>{children}</>;
  }
  return (
    <a href={url.href} title={title} target="_blank" rel="noopener noreferrer"
      className="break-words font-medium text-cyan-300 underline underline-offset-2 hover:text-cyan-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-cyan-300">
      {children}
    </a>
  );
};

const NPCDialogueText: React.FC<{ children: string }> = ({ children }) => (
  <Markdown
    className="min-w-0 break-words text-white leading-relaxed [&_p]:whitespace-pre-line [&_p]:mb-3 [&_p:last-child]:mb-0"
    options={{
      disableParsingRawHTML: true,
      forceBlock: true,
      forceWrapper: true,
      overrides: {
        a: DialogueLink,
        // Rich dialogue does not need remotely loaded images or embedded media.
        img: ({ alt }: { alt?: string }) => <span>{alt}</span>,
        ul: { props: { className: 'my-3 list-disc space-y-1 pl-6' } },
        ol: { props: { className: 'my-3 list-decimal space-y-1 pl-6' } },
        blockquote: { props: { className: 'my-3 border-l-2 border-cyan-500 pl-3 text-gray-200' } },
        h1: { props: { className: 'mb-2 text-xl font-bold' } },
        h2: { props: { className: 'mb-2 text-lg font-bold' } },
        h3: { props: { className: 'mb-2 font-bold' } },
        code: { props: { className: 'rounded bg-gray-950 px-1 font-mono text-sm' } },
        pre: { props: { className: 'my-3 overflow-x-auto whitespace-pre rounded bg-gray-950 p-3' } },
      },
    }}
  >
    {children}
  </Markdown>
);

export default NPCDialogueText;
